<template>
	<div class="portal-layout">
		<v-app-bar app clipped-left color="primary" dark>
			<v-app-bar-nav-icon class="d-md-none" @click="drawer = !drawer"></v-app-bar-nav-icon>
			<span class="title ml-3 mr-5">OSBOD Student Portal</span>
			<div class="flex-grow-1"></div>
			<span class="mr-2 d-none d-sm-inline" v-if="user">{{ displayName }}</span>
			<v-menu left bottom>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on">
						<v-icon>mdi-account-circle</v-icon>
					</v-btn>
				</template>
				<v-list>
					<v-list-item @click="clickLogout">
						<v-list-item-title>Uitloggen</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>

		<v-navigation-drawer
			v-model="drawer"
			app
			clipped
			:permanent="$vuetify.breakpoint.mdAndUp"
			:temporary="$vuetify.breakpoint.smAndDown"
		>
			<v-list nav dense>
				<v-list-item
					v-for="item in menuItems"
					:key="item.to"
					:to="item.to"
					:exact="item.exact !== false"
					link
				>
					<v-list-item-icon>
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>

		<v-content>
			<v-container fluid>
				<router-view></router-view>
			</v-container>
		</v-content>

		<v-footer app>
			<div class="flex-grow-1"></div>&copy; ICTC B.V. — OSBOD Student Portal
		</v-footer>
	</div>
</template>

<script>
export default {
	name: "portal-layout",
	data: function() {
		return {
			drawer: true,
			menuItems: [
				{ title: "Mijn profiel", to: "/main", icon: "mdi-account", exact: true },
				{ title: "Financieel", to: "/main/financieel", icon: "mdi-cash-multiple", exact: true },
				{ title: "Inhaallessen", to: "/main/inhaallessen", icon: "mdi-calendar-clock", exact: false }
			]
		};
	},
	computed: {
		user() {
			return (
				this.$store.getters.getUser ||
				JSON.parse(localStorage.getItem("user") || "null")
			);
		},
		access() {
			return (
				this.$store.getters.getLoggedin ||
				localStorage.getItem("access") === "true"
			);
		},
		displayName() {
			if (!this.user) return "";
			if (this.user.display_name) return this.user.display_name;
			return [this.user.firstname, this.user.middlename, this.user.surname]
				.filter(Boolean)
				.join(" ");
		}
	},
	created() {
		if (!this.access) {
			this.$router.replace({ path: "/" });
		}
		if (this.$vuetify.breakpoint.smAndDown) {
			this.drawer = false;
		}
	},
	methods: {
		clickLogout() {
			this.$store.dispatch("logout");
		}
	}
};
</script>
